import { useId } from "react";
import type { LeagueSummary } from "@tnp/contracts";
import { getLeagueTexts } from "../leagueTexts";
import LeagueCover from "./LeagueCover";

export default function LeagueCard({ league, management = false, onEdit }: { league: LeagueSummary; management?: boolean; onEdit?: (id: string) => void }) {
  const t = getLeagueTexts();
  const titleId = useId();
  return <article className="league-event-card">
    <a href={management ? `#/organizador/ligas/${league.id}` : `#/ligas/${league.id}`} aria-labelledby={titleId} onClick={event => {
      if (management && onEdit && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault(); onEdit(league.id);
      }
    }}>
      <LeagueCover imageUrl={league.imageUrl}>
        <span className={`league-cover-status league-status league-status--${league.status}`}>{t[league.status]}</span>
      </LeagueCover>
      <div className="league-event-card-body">
        <h2 id={titleId}>{league.name}</h2>
        {league.description && <p className="league-event-card-description">{league.description}</p>}
        <p className="league-event-card-location"><span className="material-symbols-outlined" aria-hidden="true">location_on</span>{league.venue || t.noVenue}</p>
        <p>{t.organizer}: {league.organizerName}</p>
      </div>
    </a>
  </article>;
}
